import React from 'react';
import { Mail, Phone, MapPin, Lock } from 'lucide-react';
import neruslogo from '../../Assests/nerusgroupbg.png'

const Footer = () => {
  return (
    <footer className="bg-[#01030e] border-t border-white/5 relative z-10 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 border-b border-white/5 pb-12 mb-12">

        {/* Brand Column */}
        <div className="space-y-5">
          <div className="flex items-center space-x-3.5">
            <div>
              <img src={neruslogo} alt="neruslogo" className='w-40 h-25' />
            </div>
            {/* <div>
              <span className="text-white font-extrabold text-xl tracking-widest block">NERUS</span>
              <span className="text-[9px] text-slate-500 font-bold uppercase tracking-[0.35em] block -mt-1.5 font-mono">SOVEREIGN</span>
            </div> */}
          </div>
          <p className="text-xs text-slate-400 leading-relaxed font-sans">
            Secure institutional-grade asset compounding systems driven by elite risk parameters and algorithmic orchestration.
          </p>
          <div className="flex items-center space-x-4 pt-2">
            <a href="https://www.instagram.com/nerusgroup?utm_source=qr" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform">
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="ig-grad" x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FEDA75" />
                    <stop offset="0.25" stopColor="#FA7E1E" />
                    <stop offset="0.5" stopColor="#D62976" />
                    <stop offset="0.75" stopColor="#962FBF" />
                    <stop offset="1" stopColor="#4F5BD5" />
                  </linearGradient>
                </defs>
                <path d="M7.8 2H16.2C19.4 2 22 4.6 22 7.8V16.2C22 19.4 19.4 22 16.2 22H7.8C4.6 22 2 19.4 2 16.2V7.8C2 4.6 4.6 2 7.8 2Z" fill="url(#ig-grad)" />
                <path d="M12 7.6C9.6 7.6 7.6 9.6 7.6 12C7.6 14.4 9.6 16.4 12 16.4C14.4 16.4 16.4 14.4 16.4 12C16.4 9.6 14.4 7.6 12 7.6ZM12 14.5C10.6 14.5 9.5 13.4 9.5 12C9.5 10.6 10.6 9.5 12 9.5C13.4 9.5 14.5 10.6 14.5 12C14.5 13.4 13.4 14.5 12 14.5Z" fill="white" />
                <circle cx="16.5" cy="7.5" r="1.15" fill="white" />
              </svg>
            </a>
            <a href="https://youtube.com/@nerusgroup?si=I667bV7a0Xd_bGk2" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform">
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.582 6.425C21.328 5.485 20.575 4.732 19.635 4.478C17.92 4.022 12 4.022 12 4.022C12 4.022 6.08 4.022 4.365 4.478C3.425 4.732 2.672 5.485 2.418 6.425C1.962 8.14 1.962 12 1.962 12C1.962 12 1.962 15.86 2.418 17.575C2.672 18.515 3.425 19.268 4.365 19.522C6.08 19.978 12 19.978 12 19.978C12 19.978 17.92 19.978 19.635 19.522C20.575 19.268 21.328 18.515 21.582 17.575C22.038 15.86 22.038 12 22.038 12C22.038 12 22.038 8.14 21.582 6.425Z" fill="#FF0000" />
                <path d="M9.982 15.425L15.195 12L9.982 8.575V15.425Z" fill="white" />
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="space-y-4">
          <h4 className="text-xs font-black uppercase tracking-wider text-slate-300 font-bold">Quick Anchors</h4>
          <div className="space-y-2.5 text-xs text-slate-400">
            <a href="/mutualfunds" className="block hover:text-white transition-colors">Mutual Funds</a>
            <a href="/pms" className="block hover:text-white transition-colors">PMS</a>
            <a href="/demataccount" className="block hover:text-white transition-colors">DEMAT ACCOUNT</a>
            <a href="/insurance" className="block hover:text-white transition-colors">Insurance Portal</a>
            <a href="/fixeddeposit" className="block hover:text-white transition-colors">Fixed Deposit</a>
            <a href="/aboutus" className="block hover:text-white transition-colors">About Us</a>
          </div>
        </div>

        {/* Contact Gateway */}
        <div className="space-y-4">
          <h4 className="text-xs font-black uppercase tracking-wider text-slate-300 font-mono font-bold">Contact Gateway</h4>
          <div className="space-y-3 text-xs text-slate-400 font-mono">
            <div className="flex items-center space-x-2.5">
              <Mail className="w-4 h-4 text-cyan-500 shrink-0" />
              <span>support@nerusgroup.com</span>
            </div>
            <div className="flex items-center space-x-2.5">
              <Phone className="w-4 h-4 text-cyan-500 shrink-0" />
              <span>+91 95509 71777</span>
            </div>
            <div className="flex items-center space-x-2.5">
              <MapPin className="w-4 h-4 text-cyan-500 shrink-0" />
              <span>KHAMMAM, TELANGANA, INDIA - 507002</span>
            </div>
          </div>
        </div>

        {/* Corporate Security */}
        <div className="space-y-4">
          <h4 className="text-xs font-black uppercase tracking-wider text-slate-300 font-bold">Corporate Security</h4>
          <div className="space-y-2.5 text-xs text-slate-400 leading-normal font-sans">
            <p>Certified asset-matching platform under structural family governance frameworks.</p>
            <div className="inline-flex items-center space-x-1 px-2.5 py-1 bg-white/5 border border-white/10 rounded-md">
              <Lock className="w-3.5 h-3.5 text-emerald-400 mr-1.5" />
              <span className="text-[9px] font-mono tracking-wider font-bold uppercase text-slate-300">SHA-256 Ledger</span>
            </div>
          </div>
        </div>

      </div>

      {/* Copyright & Meta */}
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-[11px] text-slate-500">
        <p>© {new Date().getFullYear()} NERUS GROUP LIMITED. ALL SECURED RIGHTS RESERVED.</p>
        <p className="mt-4 sm:mt-0 font-mono">POWERED BY KPS ENTERPRISES</p>
      </div>
    </footer>
  );
};

export default Footer;
